import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from "react";
/**
 * The order being paid for, when there is one.
 *
 * The card forms are shared between checkout and account billing, so a payment
 * step deep in that tree cannot otherwise tell whether an order exists. Undefined
 * outside checkout, which is correct: saving a card to a profile prices nothing.
 */
export const EcommerceOrderContext = React.createContext(undefined);
/** Callers memoize `order`; a fresh object per render re-renders every consumer. */
export const EcommerceOrderProvider = ({ order, children }) => (_jsx(EcommerceOrderContext.Provider, Object.assign({ value: order }, { children: children })));
export const useEcommerceOrder = () => useContext(EcommerceOrderContext);
